import { Layers } from 'lucide-react'
import type { HuntType, LocationKind } from '@/shared/domain'
import { allowedLocationKinds, fieldOrZoneLabel } from '@/shared/domain'
import { ToggleGroup, ToggleGroupItem } from '@/shared/ui/primitives'
import { FeatureIcon } from './feature-icon'

const ALL_KINDS: Set<LocationKind> = new Set([
  'blind',
  'stand',
  'zone',
  'custom',
])

export type LocationKindToggleProps = {
  huntType: HuntType | null
  value: LocationKind
  onChange: (next: LocationKind) => void
  compact?: boolean
}

export function LocationKindToggle({
  huntType,
  value,
  onChange,
  compact = false,
}: LocationKindToggleProps) {
  const kinds = huntType ? allowedLocationKinds(huntType) : ALL_KINDS
  const zoneLabel = huntType ? fieldOrZoneLabel(huntType) : 'Zone'

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(val) => {
        if (!val) return
        onChange(val as LocationKind)
      }}
      size={compact ? 'sm' : undefined}
      className={compact ? 'w-auto shrink-0' : 'w-full'}
    >
      {kinds.has('blind') ? (
        <ToggleGroupItem value="blind" aria-label="Blind" className={compact ? 'gap-1.5' : 'flex-1 gap-2'}>
          <FeatureIcon type="blind" size={16} />
          Blind
        </ToggleGroupItem>
      ) : null}
      {kinds.has('stand') ? (
        <ToggleGroupItem value="stand" aria-label="Stand" className={compact ? 'gap-1.5' : 'flex-1 gap-2'}>
          <FeatureIcon type="stand" size={16} />
          Stand
        </ToggleGroupItem>
      ) : null}
      {kinds.has('zone') ? (
        <ToggleGroupItem value="zone" aria-label={zoneLabel} className={compact ? 'gap-1.5' : 'flex-1 gap-2'}>
          <Layers className="size-4" />
          {zoneLabel}
        </ToggleGroupItem>
      ) : null}
      {kinds.has('custom') ? (
        <ToggleGroupItem value="custom" aria-label="Spot" className={compact ? 'gap-1.5' : 'flex-1 gap-2'}>
          <FeatureIcon type="spot" size={16} />
          Spot
        </ToggleGroupItem>
      ) : null}
    </ToggleGroup>
  )
}
